// extracted by mini-css-extract-plugin
export var cardIcon = "_92-4";
export var checkboxCard = "_92-0";
export var checkboxCardSelected = "_92-3";
export var disabled = "_92-1";
export var outerBorder = "_92-2";
export var spacerMedium = "_92-7";
export var spacerSmall = "_92-6";
export var spacerXsmall = "_92-5";